'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    caption1StrongClassNames: function() {
        return caption1StrongClassNames;
    },
    useCaption1StrongStyles: function() {
        return useCaption1StrongStyles;
    }
});
const _react = require("@griffel/react");
const caption1StrongClassNames = {
    root: 'fui-Caption1Strong'
};
const useCaption1StrongStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "fwrc4pm"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}"
    ]
});
